export enum APIResponseCodeEnum {
  user_error = 400,
  invalid_token = 401,
  server_error = 500,
}
